import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { getHotMovies } from '@/mocks/movies';

export default function HotRecommendations() {
  const hotMovies = getHotMovies().slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              大家都在看的精彩内容
            </p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}